import React from 'react';
import { Search } from 'lucide-react';
import { Link } from 'react-router-dom';
const Hero = () => {
  return <div className="relative w-full bg-cover bg-center h-[600px] flex items-center" style={{
    backgroundImage: "url('https://images.unsplash.com/photo-1591221568082-a172c2e3c6b2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80')"
  }} data-id="element-456">
      <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-457"></div>
      <div className="container mx-auto px-4 md:px-8 relative z-10 text-white" data-id="element-458">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-459">
          Your Trusted Travel Companion
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-2xl" data-id="element-460">
          Specializing in meaningful and enriching journeys
        </p>
        <div className="flex flex-wrap gap-4 mb-8" data-id="element-461">
          <Link to="/umrah" className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-462">
            Book Umrah
          </Link>
          <Link to="/wisata" className="bg-transparent border-2 border-white hover:bg-white hover:text-navy-900 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-463">
            Explore Tours
          </Link>
        </div>
        {/* Search Bar */}
        <div className="max-w-3xl bg-white rounded-md shadow-lg flex overflow-hidden" data-id="element-464">
          <input type="text" placeholder="Search for destinations or packages..." className="flex-grow px-4 py-3 text-navy-900 focus:outline-none" data-id="element-465" />
          <button className="bg-navy-900 text-white px-6 py-3 flex items-center justify-center hover:bg-navy-800 transition-colors" data-id="element-466">
            <Search size={20} data-id="element-467" />
          </button>
        </div>
      </div>
    </div>;
};
export default Hero;